const BasicField = ({ label, value }) => {
  return (
    <div>
      <p className="align1Calc align-topCalc align_smCalc align_xsCalc">{label}</p>
      <div className="align1_dataCalc">{value || "--"}</div>
    </div>
  );
};

export default BasicField;